import { callApiWithoutToken } from './api';

import { ApiResult } from '@/types/api';
import { SupportPlanStatusRequest, SupportPlanDraftStatusRequest } from '@/types/supportPlan';

// 個別支援計画案のステータスを更新（承認・差し戻し）
export const updateSupportPlanDraftStatus = async (
  childID: number,
  supportPlanDraftID: number,
  lineAccessToken: string,
  input: SupportPlanDraftStatusRequest
): Promise<ApiResult<{ success: boolean }>> => {
  const { status, result } = await callApiWithoutToken<{ success: boolean }>(
    `line/children/${childID}/support-plan-drafts/${supportPlanDraftID}/status`,
    'PUT',
    lineAccessToken,
    undefined,
    input
  );
  return { status, result };
};

// 個別支援計画のステータスを更新（承認・差し戻し）
export const updateSupportPlanStatus = async (
  childID: number,
  supportPlanID: number,
  lineAccessToken: string,
  input: SupportPlanStatusRequest
): Promise<ApiResult<{ success: boolean }>> => {
  const { status, result } = await callApiWithoutToken<{ success: boolean }>(
    `line/children/${childID}/support-plans/${supportPlanID}/status`,
    'PUT',
    lineAccessToken,
    undefined,
    input
  );
  return { status, result };
};
